(function(angular) {
  'use strict';

  var module = angular.module('onvio.reports');

  module.constant('DocumentType', {
    Vacation: 'VACATION',
    Termination: 'TERMINATION',
    Payslip: 'PAYSLIP',
    Other: 'OTHERS',
    Income: 'INCOME_RECEIPTS'
  });

  module.constant('FlexgridConstants', {
    Height: {
      Headers: 48,
      Columns: 37,
      Invisible: 0
    }
  });
})(window.angular);
